export default "/backend/static/media/charge_code.651a1f96.png";